// Tiempo relativo en espanol: "Hace un momento", "Hace 3 horas", "Ayer", "Hace 4 dias";
// desde 7 dias, la fecha dd/mm/aaaa. Recibe una fecha ISO / Date / timestamp.
export function tiempoRelativo(fecha, ahora = new Date()) {
  const f = new Date(fecha);
  if (!fecha || isNaN(f)) return "";
  const min = Math.floor((ahora - f) / 60000);
  if (min < 1) return "Hace un momento";
  if (min < 60) return `Hace ${min} ${min === 1 ? "minuto" : "minutos"}`;
  const horas = Math.floor(min / 60);
  const dia = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const dias = Math.round((dia(ahora) - dia(f)) / 86400000);
  if (horas < 24 && dias < 1) return `Hace ${horas} ${horas === 1 ? "hora" : "horas"}`;
  if (dias <= 1) return "Ayer";
  if (dias < 7) return `Hace ${dias} días`;
  const dos = (n) => String(n).padStart(2, "0");
  return `${dos(f.getDate())}/${dos(f.getMonth() + 1)}/${f.getFullYear()}`;
}
